var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EEF0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.022 10.3271C25.1871 10.3271 20.4434 15.0708 20.4434 20.9058C20.4434 26.6294 24.9198 31.2617 30.7548 31.4622C30.9329 31.4399 31.1111 31.4399 31.2447 31.4622H31.4006C34.1385 31.3708 36.7335 30.2183 38.6371 28.2483C40.5406 26.2783 41.6033 23.6452 41.6007 20.9058C41.6007 15.0708 36.857 10.3271 31.022 10.3271Z",
    fill: "#003C82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2627 36.7338C36.429 32.2215 23.6536 32.2215 15.7638 36.7338C12.1979 38.7959 10.2324 41.5857 10.2324 44.5696C10.2324 47.5536 12.1979 50.3191 15.7357 52.3569C19.6666 54.6373 24.8329 55.7775 29.9992 55.7775C35.1655 55.7775 40.3318 54.6373 44.2627 52.3569C47.8005 50.2949 49.766 47.5293 49.766 44.5211C49.7379 41.5372 47.8005 38.7716 44.2627 36.7338Z",
    fill: "#003C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericDoctor);
export default __webpack_public_path__ + "static/media/generic-doctor.f5b4572de0bcd1370d3749d5beffba8d.svg";
export { ForwardRef as ReactComponent };